<template>
    <div>
        <div v-if="!loaded" class="enqContent d-flex align-items-center">
            <strong>Loading...</strong>
            <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
        </div>

        <div v-else class="enqContent"><i v-if="disabled" class="fragment-disabled"></i>
            <form autocomplete="off" role="form" class="form form-inline">
                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="deliveryNoteNotes"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Delivery Note Notes</strong>
                    </label>
                    <label
                        for="deliveryNoteNotes"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Delivery Note Notes</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <textarea
                            v-model="deliveryNoteNotes"
                            class="form-control w-100"
                            id="deliveryNoteNotes"
                            rows="8"
                            :disabled="disabled"
                        ></textarea>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="deliveryWeight"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Delivery Weight (kg)</strong>
                    </label>
                    <label
                        for="deliveryWeight"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Delivery Weight (kg)</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="number"
                            data-always-clear="on"
                            autocomplete="off"
                            step="0.01"
                            min="0"
                            maxlength="20"
                            v-model.number="deliveryWeight"
                            class="form-control w-100"
                            id="deliveryWeight"
                            :disabled="disabled"
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="theirOrderNumber"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Their Order Number</strong>
                    </label>
                    <label
                        for="theirOrderNumber"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Their Order Number</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="text"
                            autocomplete="off"
                            maxlength="50"
                            v-model="theirOrderNumber"
                            class="form-control w-100"
                            id="theirOrderNumber"
                            :disabled="disabled"
                            data-lpignore="true"
                        >
                    </div>
                </div>

                <div class="form-group align-items-center mb-3 w-100">
                    <label
                        for="templateID"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>Document Templates</strong>
                    </label>
                    <label
                        for="templateID"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>Document Templates</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="templateID"
                            id="templateID"
                            class="form-control w-100 custom-select"
                            :disabled="disabled"
                        >
                            <option
                                v-for="code in languageCodes"
                                :key="code.ID"
                                :value="code.ID"
                            >{{ code.languageCode }}</option>
                        </select>
                    </div>
                </div>

                <div
                    class="offset-xs-0 offset-xl-3 col-xs-12 col-xl-9 d-flex align-items-center w-100"
                >
                    <div class="d-inline-block col-xl-8 px-0">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            :disabled="updating || disabled"
                            @click.prevent="onUpdate"
                        >Update</button>

                        <button
                            type="submit"
                            class="btn btn-secondary"
                            :disabled="updating"
                            @click.prevent="onGenerate"
                        >Generate</button>
                    </div>

                    <div class="d-flex align-items-center w-100" v-if="updating">
                        <strong class="ml-4">Updating...</strong>
                        <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "EnqFragmentDeliveryNote",

    props: {
        enquiry: {
            required: true,
            type: Object,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        updateEnquiry: {
            required: true,
            type: Function,
        },
    },

    data() {
        return {
            loaded: false,
            updating: false,

            templateID: this.enquiry.templateID,
            theirOrderNumber: this.enquiry.theirOrderNumber,
            deliveryNoteNotes: this.enquiry.deliveryNoteNotes,
            deliveryWeight: this.enquiry.deliveryWeight,
        };
    },

    computed: {},

    methods: {
        onGenerate() {
            this._onUpdate("generate", (data) => {
                window.open(data.enquiry.delivery_note_url);
            });
        },

        onUpdate() {
            this._onUpdate();
        },

        _onUpdate(method = "update", callback) {
            this.updating = true;

            axios
                .post("/api/enquiries/fragment/delivery-note/" + method, {
                    enquiryID: this.enquiry.id,

                    templateID: this.templateID,
                    theirOrderNumber: this.theirOrderNumber,
                    deliveryNoteNotes: this.deliveryNoteNotes,
                    deliveryWeight: this.deliveryWeight,
                })
                .then((response) => {
                    // console.log(response);
                    this.updating = false;

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        this.updateEnquiry(data.enquiry);

                        if (callback) {
                            callback(data);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.updating = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },
    },

    watch: {},

    mounted() {
        axios
            .post("/api/enquiries/fragment/delivery-note/get", {
                enquiryID: this.enquiry.id,
            })
            .then((response) => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loaded = true;
                    this.languageCodes = data.languageCodes;

                    make_input_no_0();
                }
            })
            .catch((error) => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    },
};
</script>
